module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av329-243c9f4fc9d60f8018037f8fe1562868.jpg";